import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import type { Types } from '@fiverr-private/theme';
import { useDrawerContext } from '../../..';
import { DrawerChildrenProps } from '../types';
import { DEFAULT_PADDING_X, DEFAULT_PADDING_Y } from './constants';

interface DrawerBodyProps
  extends DrawerChildrenProps,
    Types.GlobalStylingProps,
    Pick<Types.ContainerProps, 'paddingX' | 'paddingY'> {
  /** @deprecated use paddingX and paddingY instead */
  noPadding?: boolean;
}

const DrawerBody = ({
  noPadding = false,
  paddingX = DEFAULT_PADDING_X,
  paddingY = DEFAULT_PADDING_Y,
  children,
  ...restProps
}: DrawerBodyProps) => {
  const { contentRef } = useDrawerContext();

  return (
    <Container
      overflowY="auto"
      flexGrow={1}
      paddingX={noPadding ? undefined : paddingX}
      paddingY={noPadding ? undefined : paddingY}
      ref={contentRef}
      {...restProps}
    >
      {children}
    </Container>
  );
};

DrawerBody.displayName = 'DrawerBody';

export default DrawerBody;
